import React, { useState } from 'react';
import Card from '../../atoms/card';

const TabModule = ({ tabs, defaultTab, className }) => {
  const initialTab = defaultTab || tabs[0].id;
  const [activeItem, setActiveItem] = useState(initialTab);
  const activeTab = (id) => activeItem === id;
  return (
    <div className={`${className || ''}`}>
      <ul className="flex -mx-1">
        {tabs.map(({ id, name }) => (
          <li
            key={id}
            className={`shadow-tab cursor-pointer mx-1 rounded-t-lg 
                        bg-white flex-grow-default p-2 text-center uppercase font-bold text-primary 
                        ${activeTab(id) ? 'bg-white' : 'bg-gray-100 opacity-75 text-opacity-75'}`}
            onClick={() => setActiveItem(id)}
>
            {name}
          </li>
        ))}
      </ul>
      {tabs.map(
        ({ content, id }, index) =>
          activeTab(id) && <Card key={index}>{content}</Card>,
      )}
    </div>
  );
};

export default TabModule;
